(function () {
  'use strict';

  function initReveals(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-escosy-reveal]:not([data-escosy-reveal-ready])');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        node.dataset.escosyRevealReady = 'true';
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (node) {
      node.dataset.escosyRevealReady = 'true';
      node.classList.add('escosy-reveal-ready');
      observer.observe(node);
    });
  }

  function initDisclosureGroups(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-escosy-disclosure-group]:not([data-escosy-disclosure-ready])').forEach(function (group) {
      group.dataset.escosyDisclosureReady = 'true';
      group.addEventListener('toggle', function (event) {
        var opened = event.target;
        if (opened.tagName !== 'DETAILS' || !opened.open) return;
        group.querySelectorAll('details[open]').forEach(function (item) {
          if (item !== opened) item.removeAttribute('open');
        });
      }, true);
    });
  }

  function init(root) {
    initReveals(root);
    initDisclosureGroups(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
